/**
 * Compara se dois arrays são iguais.
 *
 * @Category Array
 *
 * @example
 * ```ts
 * import { isEqualArray } from '@ids/tools';
 *
 * isEqualArray([1, 2, 3], [1, 2, 3]);
 * // true
 * ```
 */
export const isEqualArray = (array1: unknown[], array2: unknown[]) => {
  if (array1.length !== array2.length) {
    return false;
  }

  return array1.every((item: unknown, index) => item === array2[index]);
};

/**
 * Ordena colunas de uma matriz.
 *
 * @Category Array
 *
 * @example
 * ```ts
 * import { sortMatrixColumnByIndex } from '@ids/tools';
 *
 * const matrix = [
 *   [3, 'b'],
 *   [1, 'a'],
 *   [2, 'c'],
 * ];
 *
 * sortMatrixColumnByIndex(matrix, 1);
 * // [
 * //   [1, 'a'],
 * //   [3, 'b'],
 * //   [2, 'c']
 * // ]
 * ```
 */
export const sortMatrixColumnByIndex = (matrix: (string | number)[][], index = 0, isAsc = true) => {
  const newColumns = [...matrix];

  newColumns.sort((a, b) => {
    if (a[index] === b[index]) {
      return 0;
    }

    const sort = a[index] < b[index] ? -1 : 1;

    return isAsc ? sort : sort * -1;
  });

  return newColumns;
};

/**
 * Gera nova lista com os itens que não estão presentes na segunda lista.
 *
 * @param baseList Lista base.
 * @param subList Lista de itens a serem removidos.
 * @returns Lista com os itens que não estão presentes na segunda lista.
 *
 * @category Array
 */
export const differenceArray = (baseList: unknown[], subList: unknown[]) =>
  baseList.filter((item) => !subList.includes(item));
